import React, { FC } from 'react';
import { ITeam } from '../types';
import { Link } from 'react-router';
import ImgTeamBorder from '@/shared/pictures/team_border.png';


interface MyTeamProps{
  team: ITeam
}

export const MyTeamItem :FC<MyTeamProps> = ({team}) => {

  return (
    <Link to={`/team?id=${team.id}`} className='myTeam_item'>
        <div className='myTeam_img-block'>
          <img className='myTeam_img' src={team.imageUrl} alt="team-img"/>
          <img className='myTeam_border' src={ImgTeamBorder} alt="team-img"/>
        </div>

        <div className='myTeam_info'>
            <p className='myTeam_name'>{team.name}</p>
            <p className='myTeam_text'>Участников: <span>{team.membersCount}</span></p>
            <p className='myTeam_text'>Шайб забито: <span>{team.totalScore}</span></p>
            <p className='myTeam_text'>Место в общем рейтинге: <span>{team.rating}</span></p>
        </div>

    </Link>
  );

};
